import P2Regular from 'components/typography/P2Regular';
import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';

/**
 * Column for the device subtype (Typ zariadenia).
 */
export default function DeviceSubtypeColumn({ data: { device } }: { data: RevisionPlanRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {device.deviceSubtype?.deviceTypeName}
    </P2Regular>
  );
}
